(async () => {
const { store, getContext, getElement } = await import("@wordpress/interactivity");

const { state, actions } = store("modules/button/lightbox", {
  state: {
  },
  // Usually triggered by event.
  actions: {
    async init() {
      const { ref } = getElement();
      const invoker = ref.querySelector("a");
      const { href, classList, innerHTML } = invoker;

      const url = new URL(href);
      let apiOrigin = url.origin;
      if (url.hostname === "youtu.be") {
        apiOrigin = "https://youtube.com";
      } 
      const oembed = new URL("/oembed", apiOrigin);
      oembed.searchParams.set("url", href);
      oembed.searchParams.set("format", "json");

      const { title, html, width, height } = await fetch(oembed).then(res => res.json());
      const iframe = new DOMParser().parseFromString(html, "text/html").querySelector("iframe");
      const embedUrl = new URL(iframe.src);
      embedUrl.searchParams.set("mute", "1");
      embedUrl.searchParams.set("enablejsapi", "1");
      iframe.src = embedUrl.href;
      iframe.style.width = "100%";
      iframe.style.height = "100%";
      iframe.style.aspectRatio = `${width} / ${height}`;

      const id = crypto.randomUUID();
      
      invoker.insertAdjacentHTML("afterend", `
      <button 
        type="button" command="show-modal" commandfor="${id}" 
        class="${classList}" title="Watch ${title}"
      >${innerHTML}</button>

      <dialog id="${id}" class="wp-lightbox-overlay is-layout-constrained max-w-none max-h-none">

        <button 
          type="button" command="close" commandfor="${id}" 
          aria-label="Close" class="close-button icon"
        >close</button>

        <figure 
          class="
            wp-block-embed is-type-video is-provider-youtube wp-block-embed-youtube 
            wp-embed-aspect-16-9 wp-has-aspect-ratio

            relative top-1/2 -translate-y-1/2
          "
        >
          <div class="wp-block-embed__wrapper">
            ${iframe.outerHTML}
          </div>
        </figure>

      </dialog>`);

      // Controls the video playback when modal is toggled.
      const modal = ref.querySelector("dialog");
      let started = false;

      modal.addEventListener("command", (event) => {
        const iframe = modal.querySelector("iframe");
        if (event.command === "show-modal") {
          modal.classList.add("active");

          // Autoplay the first time the modal is opened.
          if (!started) {
            // Autoplay requires user interaction first.
            iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
            started = true;
          }
        }
      });

      modal.addEventListener("close", () => {
        modal.classList.remove("active");
        // Pause the video when modal is closed.
        const iframe = modal.querySelector("iframe");
        iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
      });

      modal.addEventListener("click", (event) => {
        if (event.target === modal) {
          modal.close();
        }
      });

      invoker.remove();
    },
  },
  // Automatically reacts to state changes.
  callbacks: {

  },
});
})();